<template>
  <SogPage
    id="page"
    :title="_title"
  >
    <SogFlexRow>
      <PurchaseSaleReportComponent />
    </SogFlexRow>
  </SogPage>
</template>

<script setup lang="ts">
import SogPage from "@/shared/ui/SogPage.vue";
import {onMounted, ref} from "vue";
import {onBeforeRouteUpdate, } from "vue-router";
import {useSpinner} from "@/shared/composables/SogSpinner";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import PurchaseSaleReportComponent from "@/modules/Report/components/PurchaseSaleReportComponent.vue";



const _title = ref("Berichte")
const _spinner = useSpinner()


async function p_init() {
  _spinner.show()
  try {
  }
  finally {
    _spinner.hide()
  }
}

onMounted(async () => {
  await p_init()
})

onBeforeRouteUpdate(async () => {
  await p_init()
});




</script>
<style scoped>
</style>
